/**
 * 장바구니 localStorage `cart` — Cart 페이지·GNB 뱃지·결제 후 정리가 동일 해석을 쓰도록 공통화
 * (동일 classId가 문자열로 여러 번 쌓인 레거시 배열은 한 줄로 합침)
 */

export const CART_UPDATED_EVENT = 'cart-updated';

export interface CartItemEntry {
	id: string;
	quantity: number;
}

/** `localStorage.getItem('cart')` 값 또는 동일 JSON 문자열 */
export function parseCartStorage(raw: string | null): CartItemEntry[] {
	if (!raw) return [];
	try {
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];
		const seen = new Set<string>();
		const out: CartItemEntry[] = [];
		for (const x of parsed) {
			let id: string | null = null;
			if (x && typeof x === 'object' && 'id' in x) {
				const v = (x as { id: unknown }).id;
				if (typeof v === 'string') id = v;
				else if (typeof v === 'number' && Number.isFinite(v)) id = String(v);
			} else if (typeof x === 'string') {
				id = x;
			} else if (typeof x === 'number' && Number.isFinite(x)) {
				id = String(x);
			}
			if (!id || seen.has(id)) continue;
			seen.add(id);
			let qty = 1;
			if (x && typeof x === 'object' && 'quantity' in x) {
				const q = Number((x as { quantity: unknown }).quantity);
				if (Number.isFinite(q) && q >= 1) qty = Math.floor(q);
			}
			out.push({ id, quantity: qty });
		}
		return out;
	} catch {
		return [];
	}
}

/** GNB 등: 실제 장바구니 줄 수·수량 합(중복 id 제거 후) */
export function getCartBadgeCountFromRaw(raw: string | null): number {
	return parseCartStorage(raw).reduce((sum, e) => sum + e.quantity, 0);
}

export function persistCartItems(items: CartItemEntry[]): void {
	localStorage.setItem('cart', JSON.stringify(items));
	window.dispatchEvent(new CustomEvent(CART_UPDATED_EVENT));
}

/** 이미 담긴 classId면 false, 새로 넣었으면 true */
export function addClassToCartIfNew(classId: string): boolean {
	const items = parseCartStorage(localStorage.getItem('cart'));
	if (items.some((e) => e.id === classId)) return false;
	items.push({ id: classId, quantity: 1 });
	persistCartItems(items);
	return true;
}
